<template>
  <div v-show="drawerVisible">
    <el-drawer title="设置账户"
               ref="drawer"
               :visible.sync="drawerVisible"
               :close-on-press-escape="false"
               @close="colseDrawer"
               :wrapperClosable="false"
               size="78%">
      <div class="wrapper">
        <div class="row optional"></div>
        <div class="row table">
          <div style="text-align: right">
            <el-button size="small"
                       type="primary"
                       plain
                       @click="addAccount"
                       icon="el-icon-plus">新增</el-button>
          </div>

          <MyTable @selectionChange="handleSelectionChange"
                   :tableData="tableData"
                   :tableConfig="tableConfig"
                   :height="tableHeight"
                   :indexFlag="true">
            <template v-slot:index="slotData">
              {{
                ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
                slotData.scope.$index +
                1
              }}
            </template>
            <template v-slot:isDefault="slotData">
              {{ slotData.scope.row.isDefault ? "是" : "否" }}
            </template>
            <template v-slot:isAuthentication="slotData">
              <el-tag size="small"
                      type="danger"
                      v-if="slotData.scope.row.isAuthentication == 0">未认证</el-tag>
              <el-tag size="small"
                      type="success"
                      v-else>已认证</el-tag>
            </template>
            <template v-slot:operation="slotData">
              <el-button @click="setDefault(slotData.scope.row)"
                         class="chabtn"
                         size="small"
                         icon="el-icon-edit"
                         v-if="!slotData.scope.row.isDefault">设为发薪卡</el-button>
              <el-button @click="deleteCustomer(slotData.scope.row)"
                         type="danger"
                         plain
                         size="small"
                         icon="el-icon-delete">删除</el-button>
            </template>
          </MyTable>

          <Pagination style="margin-top: 10px"
                      :total="total"
                      @getNewData="PayrollUnitAccountPage"
                      ref="pagination" />
        </div>

        <div class="submit-bar">
          <el-button @click="
              () => {
                colseDrawer();
              }
            ">关 闭</el-button>
          <!-- <el-button
            type="primary"
            :loading="submitLoading"
            @click="onSubmit('form')"
            >确定</el-button
          > -->
        </div>
      </div>
      <el-dialog title="新增账户"
                 :visible.sync="dialogVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 :append-to-body="true"
                 width="660px"
                 class="colleague-dialog"
                 @close="resetForm">
        <el-form ref="form"
                 :model="form"
                 :rules="rules"
                 v-enterToNext="true">
          <el-form-item label="开户银行"
                        prop="bankName">
            <el-input v-model="form.bankName"></el-input>
          </el-form-item>

          <el-form-item label="银行卡号"
                        prop="cardNumber">
            <el-input v-model="form.cardNumber"
                      minlength="16"
                      maxlength="19"
                      @input="cardInput"></el-input>
          </el-form-item>
          <el-form-item label="开户姓名"
                        prop="accountName">
            <el-input v-model="form.accountName"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="
              () => {
                resetForm();
                dialogVisible = false;
              }
            ">关 闭</el-button>
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     @click="onSubmit('form')">确 定</el-button>
        </span>
      </el-dialog>
    </el-drawer>
  </div>
</template>

<script>
import MyTable from "@/components/Table";
import { format } from "echarts";
export default {
  components: {
    MyTable,
  },
  props: {
    visible: {
      default: false,
      type: Boolean,
      require: true,
    },
    row: {
      default: () => {
        return {};
      },
      type: null,
      require: true,
    },
    onerow: {
      type: null,
    },
  },
  data () {
    return {
      tableName: "batchAddTable",
      tableConfig: [
        {
          field: "bankName",
          label: "开户银行",
          align: "center",
          flag: true,
        },

        {
          field: "cardNumber",
          label: "银行卡号",
          align: "center",
          minWidth: 180,
          flag: true,
        },
        {
          field: "accountName",
          label: "开户姓名",
          align: "center",
          flag: true,
        },
        {
          field: "isDefault",
          label: "默认发薪卡",
          slotName: "isDefault",
          align: "center",
          flag: true,
        },
        {
          field: "tel",
          label: "认证状态",
          slotName: "isAuthentication",
          align: "center",
          width: 130,
          flag: true,
        },
        {
          label: "操作",
          slotName: "operation",
          width: 230,
          align: "right",
          flag: true,
        },
      ],
      rules: {
        cardNumber: [
          { required: true, message: "请输入卡号", trigger: "blur" },
        ],
        accountName: [
          { required: true, message: "请输入开户名", trigger: "blur" },
        ],
        bankName: [
          { required: true, message: "请输入开户行", trigger: "blur" },
        ],
      },
      drawerVisible: false,
      form: {
        img: [],
      },
      submitLoading: false,
      searchForm: {},
      dialogVisible: false,
      loading: false,
      tableData: [],
      total: 0,
      tableHeight: "",
      customerIds: [],
    };
  },
  mounted () {
    // this.getCompanyList();
  },
  methods: {
    cardInput () {
      this.$set(
        this.form,
        "cardNumber",
        this.form.cardNumber.replace(/[^\d]/g, "")
      );
    },
    deleteCustomer (row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let sendData = new FormData();
          sendData.append("id", row.id);
          this.submitLoading = true;
          console.log(sendData);
          this.$api.customer.PayrollUnitAccountDelete(sendData).then((res) => {
            this.submitLoading = false;
            if (res.error === false) {
              this.PayrollUnitAccountPage();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => { });
    },
    addAccount () {
      this.dialogVisible = true;
    },
    colseDrawer () {
      // this.resetForm();
      this.drawerVisible = false;
      this.$emit("colseDrawer");
    },
    setDefault (row) {
      let sendData = new FormData();
      sendData.append("id", row.id);
      // let sendData = {
      //   id: row.id,
      // };
      this.$api.customer.PayrollUnitAccountSetDefault(sendData).then((res) => {
        if (res.error === false) {
          this.PayrollUnitAccountPage();
          this.$message.success("设置成功");

        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        let sendData = {
          payrollUnitId: this.onerow.id,
          bankName: this.form.bankName,
          accountName: this.form.accountName,
          cardNumber: this.form.cardNumber,
        };
        this.$api.customer.PayrollUnitAccountEdit(sendData).then((res) => {
          this.submitLoading = false;
          if (res.error === false) {
            this.dialogVisible = false;
            this.PayrollUnitAccountPage();
            this.$message.success("添加成功");
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    PayrollUnitAccountPage () {
      this.loading = true;
      let Data = "";
      let sendData = {};
      this.$nextTick(() => {
        sendData = {
          pageIndex: this.$refs.pagination.currentPage,
          pageSize: this.$refs.pagination.pageSize,
          ayrollUnitId: this.onerow.id,
        };
        this.$api.customer.PayrollUnitAccountPage(sendData).then((res) => {
          this.loading = false;
          if (!res.error) {

            this.tableData = res.data.data;
            this.total = res.data.count;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    handleSelectionChange () { },
    resetForm () {
      this.customerIds = [];
      this.form = {};
      this.$refs.form.clearValidate();
    },
  },
  watch: {
    visible (newVal) {
      this.drawerVisible = newVal;
      this.PayrollUnitAccountPage();
      if (newVal) {
        this.loading = false;
      }
    },
    drawerVisible (newVal) {
      this.$emit("update", newVal);
    },
  },
};
</script>
<style lang="less" scoped>
.el-table .cell {
  white-space: pre-line !important;
}

.wrapper {
  padding: 10px 20px;
}

button.btn {
  background: #0080ff;
  border: 0px;
  color: #fff;
  padding: 5px 10px;
  margin-right: 10px;
}

button.btn:hover {
  background: #004f9e;
  cursor: pointer;
}

.number-footer {
  width: 100px;
}

.myimg {
  width: 200px;
  height: auto;
}
</style>